import { useEffect } from 'react';
import { useAccount } from 'wagmi';
import Text from '../../../atoms/Text';
import Button from '../../../molecules/Button';
import { useWallet } from '../../../wallet/walletContext';

import './styles.scss';

interface ISignAuthModalProps {
  onAuth: () => Promise<void>;
  onDisconnect: () => void;
  onCancel: () => void;
}

const SignAuthModal = ({
  onAuth,
  onDisconnect,
  onCancel,
}: ISignAuthModalProps) => {
  const { address } = useAccount();
  const { isSignLoading } = useWallet();

  useEffect(() => {
    if (!address) {
      onCancel();
    }
  }, [address, onCancel]);

  const handleClose = () => {
    onDisconnect();
    onCancel();
  };

  const handleAuth = async () => {
    await onAuth();
    onCancel();
  };

  return (
    <>
      <div className='sign_auth'>
        <div className='sign_auth__close icon-close' onClick={handleClose} />
        <Text size={16} className='text--grey-200 text--weight-600'>
          Sign for Access
        </Text>
        <div className='sign_auth__description'>
          <Text size={14} className='text--grey-400 text--weight-600'>
            By signing this message, you confirm that you are granting
            authorization for accessing this app and its features.
          </Text>
          <Text size={12} className='text--grey-400 text--weight-500'>
            Please ensure that you sign this message using your Cryptocurrency
            Wallet.
          </Text>
        </div>
        <div className='sign_auth__action'>
          <Button
            size='m'
            variant='primary'
            action={handleAuth}
            text='Sign Message'
            loading={isSignLoading}
          />
        </div>
      </div>
      <div className='wallet_modal__backdrop' onClick={handleClose} />
    </>
  );
};

export default SignAuthModal;
